import { InspectorListItem } from "@/model/InspectorListItem";
import { Uuid } from "@/dto/CommonDto.ts";

/**
 * 점검 사용자 조회 - req
 */
export class ReadInspectorDetailReqDto extends Uuid {}

/**
 * 점검 사용자 조회 - res
 */
export class ReadInspectorDetailResDto extends InspectorListItem {}
